import { render } from "./LoggedInView.vue?vue&type=template&id=4e4fbfaf&scoped=true"
import script from "./LoggedInView.vue?vue&type=script&lang=js"
export * from "./LoggedInView.vue?vue&type=script&lang=js"

import "./LoggedInView.vue?vue&type=style&index=0&id=4e4fbfaf&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4fbfaf"]])

export default __exports__